// TODO: update to be able use more than 59 seconds and move to utils

export const round = (value: number) => Math.round(value * 100) / 100
export const formatTimeValue = (value: number) =>
  `00:${Math.round(value).toString().padStart(2, "0")}`

export const poll = async function <T>(
  fn: () => Promise<T> | null,
  fnCondition: (response: T) => boolean,
  ms: number = 1000,
) {
  if (!fn) return

  let result = await fn()
  while (fnCondition(result!)) {
    await wait(ms)
    result = await fn()
  }
  return result
}

export const wait = function (ms = 1000) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms)
  })
}
